export enum ApplicationSearchType {
  MyApplicationsOnly,
  AllApplications
}
